import React, { useState, useEffect, useContext } from 'react';

import Cookies from 'js-cookie';

import Dropdown from '../../common/Dropdown/index.js'
import CampaignMenu from '../CampaignMenu.js'

import { UserDataContext } from "../../../App.js";
import { DEFAULT_CAMPAIGN, CAMPAIGN_ASSETS_URL } from '../../../globals.js';

function RulesMenuCombat(props) {

    // ------------ parameters ---------------

    // ------ inherited state variables ------
    let [currentChar, setChar] = [ props.state[0], props.state[1] ];
    let [layout, setLayout] = [ props.state[3], props.state[4] ];
    const [userData, setUserData] = useContext(UserDataContext);
    const [isPlaying, setIsPlaying] = props.state[8];
    const setRule = props.setRule;

    // -------- local state variables --------
    const [isTTS, setIsTTS] = useState(/Tabletop/i.test(navigator.userAgent));


    let menuOptions = [
            'Combat Actions',
            'Fumble Table',
            'Critical Hits',
            'To Hit'
            // ...(userData.loggedIn ? ['View > DM'] : []),
          ];

    // -------------------------------------
    // EVENT HANDLER
    // -------------------------------------

    // Returns campaign-specific S3 URL if set, otherwise Greyhawk20 S3 image
    const getRuleSource = (ruleKey, fallbackFilename) => {
        const campaignRules = userData.campaignData?.rules;
        if (campaignRules?.[ruleKey]?.url) {
            return campaignRules[ruleKey].url;
        }
        return `${CAMPAIGN_ASSETS_URL}/${DEFAULT_CAMPAIGN}/${fallbackFilename}.jpg`;
    };

    const handleMenu = async (selection) => {
        // Implement the various menu options here

        let Img;
        let imgSet = false;

        const ruleKeyMap = {
            'Fumble Table': 'fumbleTable',
            'Critical Hits': 'criticalHit',
        };

        menuOptions.forEach((option, i) => {
            if ( menuOptions[selection] === menuOptions[i] ) {
                const ruleKey = ruleKeyMap[option];
                if (ruleKey) {
                    Img = getRuleSource(ruleKey, option.replace(/\s+/g, ''));
                } else {
                    Img = require(`../../../pdf/${option.replace(/\s+/g, '')}.jpg`);
                }
                imgSet = true;
            }
        });

        // DISPLAY IMAGE IN WINDOW (if set)
        if ( imgSet ) {
            if ( props.setRule ) {
                setRule( { title: menuOptions[selection], source: Img })
            }

            document.getElementById('rulesWindow').style.display = 'block';
            // document.getElementsByClassName('rules-menu')[0].style.display = 'none';
            return;
        }


    } // end of HANDLE FUNCTION


    
    // ------------- useEffect ---------------
    /*
    useEffect( () => {

        async function DoSomething () {    
          
        }

        DoSomething();

    }, [] ); //useEffect
    */

        // ------------  Return JSX  ----------------
    
    return (
    
        <>
        <Dropdown
            trigger = {<button className="nav-settings-button">Combat</button>}
            menu = { menuOptions.map ( ( option, idx) => {

                if  ( option === 'Change Campaign' ) return <CampaignMenu key={idx} {...props} />

                else return <button id={'discord-option-' + idx } onClick={()=>handleMenu(idx)}>{option}</button>

                }
            )}
            divClass='menu-item sub-menu'
            menuClass="menu"
            onChildClose={props.onChildClose}
        />
        </>
    )

    };  // end of function

    export default RulesMenuCombat